<template>
  <final-modal v-model="modalShow" @cancel="reset">
    <template v-slot:title>{{ $t("general.attendance") }}</template>
    <div class="text-center pb-3">
      <p>
        {{ player.player }}
      </p>
      <div class="btn-group" role="group">
        <button
          type="button"
          :class="`btn ${
            player?.arrived ? 'btn-success' : 'btn-outline-success'
          }`"
          @click="setPlayerState('arrived')"
        >
          {{ $t("message.playerArrived") }}
        </button>
        <button
          type="button"
          :class="`btn ${player?.noshow ? 'btn-danger' : 'btn-outline-danger'}`"
          @click="setPlayerState('noshow')"
        >
          {{ $t("message.playerNoShow") }}
        </button>
      </div>
    </div>
  </final-modal>
</template>

<script>
import FinalModal from "@/components/shared/final_modal.vue";
import { http } from "@/http";
import { useToast } from "vue-toastification";
import { TOAST_CONFIGS } from "@/config/toasts";

export default {
  name: "SetPlayerStateModal",
  components: {
    FinalModal,
  },
  setup() {
    return { toast: useToast() };
  },
  data() {
    return {
      modalShow: false,
      player: {},
      timeSheetType: null,
    };
  },
  methods: {
    handleError(err) {
      console.error(err);
      this.toast.error(
        this.$t("error.playerAttendance"),
        TOAST_CONFIGS.INVALID_REQUEST_ERROR
      );
    },
    setPlayerState(value) {
      http
        .post(`/api/v1/time-sheet/player-state`, {
          flightId: this.flightId,
          timeSheetId: this.timeSheetId,
          type: this.timeSheetType,
          playerId: this.player.id,
          noShow: value == "noshow",
          arrived: value == "arrived",
          userName: this.$root.userInfo().name,
          userInitials: this.$root.userInfo().initials,
        })
        .then(() => this.reset())
        .catch((err) => this.handleOvertakeError(err));
    },
    reset() {
      this.modalShow = false;
      this.player = {};
      this.timeSheetType = null;
    },
    show(data) {
      this.player = data.player;
      this.timeSheetType = data.timeSheetType;
      this.timeSheetId = data.timeSheetId;
      this.flightId = data.flightId;
      this.modalShow = true;
    },
  },
};
</script>
